import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-table-row:hover .shadow-background {
    background-image: linear-gradient(to right, rgb(250 250 250 / 7%), rgb(250 250 250 / 74%));
  }
`;

export const TagContainer = styled.div`
  display: flex;
  overflow: hidden;
`;

export const ShadowTags = styled.div`
  width: 50px;
  background: rgb(255 255 255 / 37%);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(to right, rgb(255 255 255 / 16%), rgb(255 255 255));
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 100%;
`;

export const EmptyEmoji = styled.span`
  font-size: 40px;
  text-align: center;
  margin-bottom: 16px;
`;

export const EmptyTitle = styled.span`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const EmptyDescription = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;
